import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/common/setting";

export const setting = {
    // ...example,
    get(){
        return axios.get(`${url}`).then(result => result.data);
    },
    // put(data){
    //     return axios.put(`${url}`, data).then(result => result.data);
    // },
}
